'use client'

import { Button, Dialog, Cell, Text, Spacer } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  isOpen: boolean
  title: string
  text: string
  onClose: () => void
}

const TooManyAttemptsModal = ({ isOpen, title, text, onClose }: Props) => {
  const translate = useTranslate('settings.security.error.too_many_mismatches')

  return (
    <Dialog show={isOpen}>
      <Cell>
        <Text
          as="h1"
          alignment={Text.Alignment.Center}
          type={Text.Type.Heading}
          width={Text.Width.Parent}
          text={title}
        />

        <Spacer size={Spacer.Size.XLarge} />
        <Text as="span" text={text} />
        <Spacer size={Spacer.Size.XLarge} />

        <Button text={translate('button')} styling={Button.Styling.Filled} onClick={onClose} />
      </Cell>
    </Dialog>
  )
}

export default TooManyAttemptsModal
